import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'imageUrl',
  standalone: false,
})
export class ImageUrlPipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);

  transform(imageUri: string): SafeUrl {
    const api = environment.config.api;
    return this.domSanitizer.bypassSecurityTrustUrl(api + imageUri);
  }
}
